import backofficeService from '../../api/backoffice'

export default {
  getStockCount() {
    return backofficeService.Api().get('api/getStockCount')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getMissingSerialList() {
    return backofficeService.Api().get('api/invoice/missingSerialNumber')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
